let defaultFilters = {
    publisherId: {
      value: null,
      modifiers: []
    },
    type: {
      value: null,
      modifiers: {
        matchType: 'contains'
      },
    },
    frequency: {
      value: null,
      modifiers: {
        matchType: 'contains'
      },
    }
}

export const namespaced = true

export const state = {
  filters: defaultFilters,
  orderBy: []
}

export const mutations = {
  RESET_FILTERS(state) {
    state.filters = defaultFilters
  }
}

export const actions = {
  resetFilters({ commit }) {
    commit('RESET_FILTERS')
  }
}
